import { render, staticRenderFns } from "./matrix.vue?vue&type=template&id=7fa2f403&"
import script from "./matrix.vue?vue&type=script&lang=ts&"
export * from "./matrix.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fa2f403')) {
      api.createRecord('7fa2f403', component.options)
    } else {
      api.reload('7fa2f403', component.options)
    }
    module.hot.accept("./matrix.vue?vue&type=template&id=7fa2f403&", function () {
      api.rerender('7fa2f403', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/matrix.vue"
export default component.exports